export default __webpack_public_path__ + "static/media/VD6.85f202a6.png";